<template>
    <div class="loginBG">
      <Button type="primary" class="clearBtn" @click="clearBtn()"><Icon type="md-arrow-round-back" />退出登录</Button>
      <div class="clearIten"></div>
        <div class="title">
          <!-- <div :class="tabsIndex==0?'actives':''" @click="making(0)">制作记录 <p></p></div> -->
          <div :class="tabsIndex==3?'actives':''" @click="making(3)">投屏记录<p></p></div>
          <div :class="tabsIndex==1?'actives':''" @click="making(1)">发音点读 <p></p></div>
          <!-- <div :class="tabsIndex==2?'actives':''" @click="making(2)">单词竞赛 <p></p></div> -->
          </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
          <div class="loginQr" v-if="!queryListData && tabsIndex==0" >
            <img  src="../assets/miniQr.jpg" alt="" srcset="">
          </div>
          
          <div class="loginInfo" style="color:red" v-if="!queryListData && tabsIndex==0">您还没有制作任何练习卷</div>
          <div class="loginInfo" v-if="!queryListData && tabsIndex==0">扫码进入微信小程序即可制作词语练习卷进行投屏</div>
          <!-- <div class="contentBox" v-if="queryListData && tabsIndex==0">
            <div class="jiantouBox" style="color:red" v-if="tabsIndex==0">
              <img src="../assets/jiantou.png" alt="">
            </div>
            <div class="infos">现已启用专门的投屏练习制作方式，请在小程序首页的“投屏练习”中制作。原投屏采用的制作记录方式将保留至10月31日，请尽快熟悉新的制作方式，更便捷，更高效！</div>
            <Input search enter-button="查询" placeholder="请输入要查询的默写单" v-model="queryStr" @on-search="queryList1" />
              <div class="listItem" v-for="(item,index) in queryListData" :key="index">
                <span class="postIcon"></span>
                {{item.name}}
                <Button type="primary" class="showBtn3" @click="showBtn(item)">投屏默写</Button>
                <Button type="primary" class="showBtn2" @click="showStudy(item)">投屏学习</Button>
                <Button type="primary" class="showBtn1" @click="splitTpList(item)">单词拼读</Button>
                <Button type="primary" class="showBtn" @click="goLetter(item)">单词竞赛</Button>
              </div>
                
                <div class="bottomBox"><Page :current="page" show-elevator :total="total" @on-change="handlePage"  simple></Page></div>
          </div> -->

          <div class="contentBox" v-if="queryListData && tabsIndex==3">
            
            <Input search enter-button="查询" placeholder="请输入要查询的默写单" v-model="queryStr" @on-search="queryListScren" />
              <div class="listItem" v-for="(item,index) in queryListData" :key="index">
                <span class="postIcon"></span>
                {{item.name}}
                <Button type="primary" class="showBtn" @click="showBtn(item)">投屏默写</Button>
                <Button type="primary" class="showBtn2" @click="showStudy(item)">投屏学习</Button>
                <Button type="primary" class="showBtn1" @click="splitTpList(item)">单词拼读</Button>
                <Button type="primary" class="showBtn3" @click="goLetter(item)">单词竞赛</Button>
              </div>
              <!-- <Page :total="total" /> -->
                
                <div class="bottomBox"><Page :current="page" show-elevator :page-size="titleNumber" :total="total" @on-change="handlePage"  simple></Page></div>
          </div>
        
        <div class="fayin" v-if="tabsIndex==1">
          <Menu theme="light" :active-name="0" @on-select="hanTabs">
              <Menu-item :name="index" v-for="(item,index) in items" :key="index" >
                  {{item.text}}
              </Menu-item>
          </Menu>
          <!-- 单元音 -->
            <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 0">
              <div class="danItem" @click="handWord(item)" v-for="(item,index) in danList" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
              

            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 0">
              <div class="binItem">{{showzi}}</div>
              <div class="binWord" v-if="showWord == 'bean'">b<span style="color:red">ea</span>n</div>
              <div class="binWord" v-if="showWord == 'tip'">t<span style="color:red">i</span>p</div>
              <div class="binWord" v-if="showWord == 'met'">m<span style="color:red">e</span>t</div>
              <div class="binWord" v-if="showWord == 'pan'">p<span style="color:red">a</span>n</div>
              <div class="binWord" v-if="showWord == 'moon'">m<span style="color:red">oo</span>n</div>
              <div class="binWord" v-if="showWord == 'the'">th<span style="color:red">e</span></div>
              <div class="binWord" v-if="showWord == 'sir'">s<span style="color:red">ir</span></div>
              <div class="binWord" v-if="showWord == 'fun'">f<span style="color:red">u</span>n</div>
              <div class="binWord" v-if="showWord == 'card'">c<span style="color:red">ar</span>d</div>
              <div class="binWord" v-if="showWord == 'shook'">sh<span style="color:red">oo</span>k</div>
              <div class="binWord" v-if="showWord == 'shore'">sh<span style="color:red">or</span>e</div>
              <div class="binWord" v-if="showWord == 'lock'">l<span style="color:red">o</span>ck</div>
              <img :src="showImages"></img>
          </div>
          <!-- 双元音 -->
          <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 1">
              <div class="danItem" @click="handWord1(item)" v-for="(item,index) in danList1" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
          </div>
          <div slot="content" class="shouMin" v-if="mainActiveIndex == 1">
              <div class="binItem">{{showzi1}}</div>
              <div class="binWord" v-if="showWord1 == 'dear'">d<span style="color:red">ear</span></div>
              <div class="binWord" v-if="showWord1 == 'same'">s<span style="color:red">a</span>me</div>
              <div class="binWord" v-if="showWord1 == 'loud'">l<span style="color:red">ou</span>d</div>
              <div class="binWord" v-if="showWord1 == 'go'">g<span style="color:red">o</span></div>
              <div class="binWord" v-if="showWord1 == 'choice'">ch<span style="color:red">oi</span>ce</div>
              <div class="binWord" v-if="showWord1 == 'hide'">h<span style="color:red">i</span>de</div>
              <div class="binWord" v-if="showWord1 == 'curious'">c<span style="color:red">ur</span>ious</div>
              <img :src="showImages1"></img>
          </div>

          <!-- 摩擦音 -->
          <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 2">
            <div class="danItem" @click="handWord2(item)" v-for="(item,index) in danList2" :key="index">
            <div class="titiles">{{item.num}}</div>
            <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
            </div>
          </div>
          <div slot="content" class="shouMin" v-if="mainActiveIndex == 2">
            <div class="binItem">{{showzi2}}</div>
            <div class="binWord" v-if="showWord2 == 'first'"><span style="color:red">f</span>irst</div>
              <div class="binWord" v-if="showWord2 == 'van'"><span style="color:red">v</span>an</div>
              <div class="binWord" v-if="showWord2 == 'thick'"><span style="color:red">th</span>ick</div>
              <div class="binWord" v-if="showWord2 == 'these'"><span style="color:red">th</span>ese</div>
              <div class="binWord" v-if="showWord2 == 'saw'"><span style="color:red">s</span>aw</div>
              <div class="binWord" v-if="showWord2 == 'zen'"><span style="color:red">z</span>en</div>
              <div class="binWord" v-if="showWord2 == 'she'"><span style="color:red">sh</span>e</div>
              <div class="binWord" v-if="showWord2 == 'casual'">ca<span style="color:red">s</span>ual</div>
              <div class="binWord" v-if="showWord2 == 'hard'"><span style="color:red">h</span>ard</div>
              <img :src="showImages2"></img>
          </div>
          <!-- 爆破音 -->
           <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 3">
              <div class="danItem" @click="handWord3(item)" v-for="(item,index) in danList3" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 3">
                <div class="binItem">{{showzi3}}</div>
                <div class="binWord" v-if="showWord3 == 'pick'"><span style="color:red">p</span>ick</div>
                <div class="binWord" v-if="showWord3 == 'bed'"><span style="color:red">b</span>ed</div>
                <div class="binWord" v-if="showWord3 == 'thick'"><span style="color:red">th</span>ick</div>
                <div class="binWord" v-if="showWord3 == 'team'"><span style="color:red">t</span>eam</div>
                <div class="binWord" v-if="showWord3 == 'dine'"><span style="color:red">d</span>ine</div>
                <div class="binWord" v-if="showWord3 == 'code'"><span style="color:red">c</span>ode</div>
                <div class="binWord" v-if="showWord3 == 'get'"><span style="color:red">g</span>et</div>
                <img :src="showImages3"></img>
            </div>

              <!-- 破擦音 -->
            <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 4">
              <div class="danItem" @click="handWord4(item)"  v-for="(item,index) in danList4" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 4">
                <div class="binItem">{{showzi4}}</div>
                <div class="binWord" v-if="showWord4 == 'choose'"><span style="color:red">ch</span>oose</div>
                <div class="binWord" v-if="showWord4 == 'jet'"><span style="color:red">j</span>et</div>
                <img :src="showImages4"></img>
            </div>

            <!-- 延续音 -->
            <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 5">
              <div class="danItem" @click="handWord5(item)" v-for="(item,index) in danList5" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
             
              </div>
             
            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 5">
                <div class="binItem">{{showzi5}}</div>
                <div class="binWord" v-if="showWord5 == 'watch'"><span style="color:red">w</span>atch</div>
                <div class="binWord" v-if="showWord5 == 'rug'"><span style="color:red">r</span>ug</div>
                <div class="binWord" v-if="showWord5 == 'yet'"><span style="color:red">y</span>et</div>
                <img :src="showImages5"></img>
            </div>

            <!-- 边音 -->
            <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 6">
              <div class="danItem" @click="handWord6(item)" v-for="(item,index) in danList6" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 6">
                <div class="binItem">{{showzi6}}</div>
                <div class="binWord" v-if="showWord6 == 'look'"><span style="color:red">l</span>ook</div>
                <img :src="showImages6"></img>
            </div>

            <!-- 鼻腔音 -->
            <div slot="content" class="danBoxContent" v-if="mainActiveIndex == 7">
              <div class="danItem" @click="handWord7(item)" v-for="(item,index) in danList7" :key="index">
              <div class="titiles">{{item.num}}</div>
              <div class="wordIten"><span v-if="!item.isPlay">{{item.zi}}</span><span v-if="item.isPlay" style="color: #FEBC67;">{{item.zi}}</span></div>
              </div>
            </div>
            <div slot="content" class="shouMin" v-if="mainActiveIndex == 7">
                <div class="binItem">{{showzi7}}</div>
                <div class="binWord" v-if="showWord7 == 'mode'"><span style="color:red">m</span>ode</div>
                <div class="binWord" v-if="showWord7 == 'neck'"><span style="color:red">n</span>eck</div>
                <div class="binWord" v-if="showWord7 == 'song'">so<span style="color:red">ng</span></div>
                <img :src="showImages7"></img>
            </div>

        </div>



        <div class="loginQr" v-if="!queryListData && tabsIndex==2" >
            <img  src="../assets/miniQr.jpg" alt="" srcset="">
          </div>
          
          <div class="loginInfo" style="color:red" v-if="!queryListData && tabsIndex==2">您还没有制作任何练习卷</div>
          <div class="loginInfo" v-if="!queryListData && tabsIndex==2">扫码进入微信小程序即可制作词语练习卷进行投屏</div>
          <div class="contentBox" v-if="queryListData && tabsIndex==2">
            <Input search enter-button="查询" placeholder="请输入要查询的默写单" v-model="queryStr" @on-search="queryList1" />
              <div class="listItem" v-for="(item,index) in queryListData" :key="index">
                <span class="postIcon"></span>
                {{item.name}}
                <Button type="primary" class="showBtn" @click="goLetter(item)">单词竞赛</Button>
                <!-- <Button type="primary" class="showBtn" @click="showStudy(item)">单词竞赛</Button> -->
              </div>
              <!-- <Page :total="total" /> -->
                
                <div class="bottomBox"><Page :current="page" show-elevator :total="total" @on-change="handlePage"  simple></Page></div>
          </div>




        <audio ref="audio"  controls="controls" class="audiosBox" @ended="overAudio"></audio>
    </div>

</template>
  
<script>
import axios from "axios";
import qs from "qs"
import ASEUrl from "../cryptojs/secret"
export default {
    data() {
      return {
        queryListData:[],
        total:0,
        page:1,
        num:10,
        spinShow:true,
        tabsIndex:3,
        titleNumber:10,
         items: [{
        text: '单元音',
      },
      {
        text: '双元音'
      },
      {
        text: '摩擦音'
      },
      {
        text: '爆破音'
      },
      {
        text: '破擦音'
      },
      {
        text: '延续音'
      },
      {
        text: '边音'
      },
      {
        text: '鼻腔音'
      },
        ],
        mainActiveIndex: 0,
        activeId: [],
        // 单元音
         danList: [{
            num: 1,
            zi: 'i:',
            index: 0,
            word: 'bean',
            image: 'https://r.bjwxjs.com/EnAudio/1.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_201.mp3',
            isPlay: false,
          },
          {
            num: 2,
            zi: 'ɪ',
            word: 'tip',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/2.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_202.mp3',
            isPlay: false,
          },
          {
            num: 3,
            zi: 'e',
            word: 'met',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/3.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_203.mp3',
            isPlay: false,
          },
          {
            num: 4,
            zi: 'æ',
            word: 'pan',
            isPlay: false,
            index: 3,
            image: 'https://r.bjwxjs.com/EnAudio/5.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_205.mp3'
          },
          {
            num: 5,
            zi: 'u:',
            word: 'moon',
            isPlay: false,
            index: 4,
            image: 'https://r.bjwxjs.com/EnAudio/6.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_206.mp3'
          },
          {
            num: 6,
            zi: 'ə',
            word: 'the',
            isPlay: false,
            index: 5,
            image: 'https://r.bjwxjs.com/EnAudio/7.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_207.mp3'
          },
          {
            num: 7,
            zi: 'ɜː',
            word: 'sir',
            isPlay: false,
            index: 6,
            image: 'https://r.bjwxjs.com/EnAudio/8.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_208.mp3'
          },
          {
            num: 8,
            zi: 'ʌ',
            word: 'fun',
            isPlay: false,
            index: 7,
            image: 'https://r.bjwxjs.com/EnAudio/9.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_209.mp3'
          },
          {
            num: 9,
            zi: 'ɑː',
            word: 'card',
            isPlay: false,
            index: 8,
            image: 'https://r.bjwxjs.com/EnAudio/10.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2010.mp3'
          },
          {
            num: 10,
            zi: 'ʊ',
            word: 'shook',
            isPlay: false,
            index: 9,
            image: 'https://r.bjwxjs.com/EnAudio/11.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2011.mp3'
          },
          {
            num: 11,
            zi: 'ɔ:',
            word: 'shore',
            isPlay: false,
            index: 10,
            image: 'https://r.bjwxjs.com/EnAudio/12.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2012.mp3'
          },
          {
            num: 12,
            zi: 'ɒ',
            word: 'lock',
            isPlay: false,
            index: 11,
            image: 'https://r.bjwxjs.com/EnAudio/13.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2013.mp3'
          },
        ],
        showImages: 'https://r.bjwxjs.com/EnAudio/1.png',
        showWord: 'bean',
        showzi: 'i:',

        // 双元音
         danList1: [{
            num: 13,
            zi: 'ɪə',
            index: 0,
            word: 'dear',
            image: 'https://r.bjwxjs.com/EnAudio/14.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2014.mp3',
            isPlay: false,
          },
          {
            num: 14,
            zi: 'eɪ',
            word: 'same',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/15.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2015.mp3',
            isPlay: false,
          },
          {
            num: 15,
            zi: 'aʊ',
            word: 'loud',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/16.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2016.mp3',
            isPlay: false,
          },
          {
            num: 16,
            zi: 'əʊ',
            word: 'go',
            index: 3,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/17.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2017.mp3'
          },
          {
            num: 17,
            zi: 'aɪ',
            word: 'hide',
            index: 4,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/18.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2018.mp3'
          },
          {
            num: 18,
            zi: 'ɔɪ',
            word: 'choice',
            index: 5,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/19.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2019.mp3'
          },
          {
            num: 19,
            zi: 'ʊə',
            index: 6,
            word: 'curious',
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/20.gif',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2020.mp3'
          },
          {
            num: 20,
            zi: 'ɛː/eə',
            word: 'hair',
            index: 7,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/4.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_204.mp3'
          },
        ],
        showImages1: 'https://r.bjwxjs.com/EnAudio/14.gif',
        showWord1: 'dear',
        showzi1: 'ɪə',

        // 摩擦音
        danList2: [{
            num: 21,
            zi: 'f',
            index: 0,
            word: 'first',
            image: 'https://r.bjwxjs.com/EnAudio/21.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2021.mp3',
            isPlay: false,
          },
          {
            num: 22,
            zi: 'v',
            word: 'van',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/22.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2022.mp3',
            isPlay: false,
          },
          {
            num: 23,
            zi: 'θ',
            word: 'thick',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/23.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2023.mp3',
            isPlay: false,
          },
          {
            num: 24,
            zi: 'ð',
            word: 'these',
            index: 3,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/24.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2024.mp3'
          },
          {
            num: 25,
            zi: 's',
            word: 'saw',
            index: 4,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/25.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2025.mp3'
          },
          {
            num: 26,
            zi: 'z',
            word: 'zen',
            index: 5,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/26.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2026.mp3'
          },
          {
            num: 27,
            zi: 'ʃ',
            index: 6,
            word: 'she',
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/27.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2027.mp3'
          },
          {
            num: 28,
            zi: 'ʒ',
            index: 7,
            word: 'casual',
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/28.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2028.mp3'
          },
          {
            num: 29,
            zi: 'h',
            index: 8,
            word: 'hard',
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/29.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2029.mp3'
          },
        ],
        showImages2: 'https://r.bjwxjs.com/EnAudio/21.png',
        showWord2: 'first',
        showzi2: 'ɜː',

        // 爆破音
        danList3: [{
            num: 30,
            zi: 'p',
            index: 0,
            word: 'pick',
            image: 'https://r.bjwxjs.com/EnAudio/30.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2030.mp3',
            isPlay: false,
          },
          {
            num: 31,
            zi: 'b',
            word: 'bed',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/31.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2031.mp3',
            isPlay: false,
          },
          {
            num: 32,
            zi: 't',
            word: 'team',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/32.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2032.mp3',
            isPlay: false,
          },
          {
            num: 33,
            zi: 'd',
            word: 'dine',
            index: 3,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/33.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2033.mp3'
          },
          {
            num: 34,
            zi: 'k',
            word: 'code',
            index: 4,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/34.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2034.mp3'
          },
          {
            num: 35,
            zi: ' ɡ',
            word: 'get',
            index: 5,
            isPlay: false,
            image: 'https://r.bjwxjs.com/EnAudio/35.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2035.mp3'
          }
        ],
        showImages3: 'https://r.bjwxjs.com/EnAudio/30.png',
        showWord3: 'pick',
        showzi3: 'p',

        // 破擦音
        danList4: [{
            num: 36,
            zi: 'tʃ',
            index: 0,
            word: 'choose',
            image: 'https://r.bjwxjs.com/EnAudio/36.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2036.mp3',
            isPlay: false,
          },
          {
            num: 37,
            zi: 'dʒ',
            word: 'jet',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/37.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2037.mp3',
            isPlay: false,
          }
        ],
        showImages4: 'https://r.bjwxjs.com/EnAudio/36.png',
        showWord4: 'choose',
        showzi4: 'tʃ',

        // 延续音
        danList5: [{
            num: 38,
            zi: 'w',
            index: 0,
            word: 'watch',
            image: 'https://r.bjwxjs.com/EnAudio/38.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2038.mp3',
            isPlay: false,
          },
          {
            num: 39,
            zi: 'r',
            word: 'rug',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/39.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2039.mp3',
            isPlay: false,
          },
          {
            num: 40,
            zi: ' j',
            word: 'yet',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/40.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2040.mp3',
            isPlay: false,
          }
        ],
        showImages5: 'https://r.bjwxjs.com/EnAudio/38.png',
        showWord5: 'watch',
        showzi5: 'w',

        // 边音
        danList6: [{
            num: 41,
            zi: 'l',
            index: 0,
            word: 'look',
            image: 'https://r.bjwxjs.com/EnAudio/41.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2041.mp3',
            isPlay: false,
          }
        ],
        showImages6: 'https://r.bjwxjs.com/EnAudio/41.png',
        showWord6: 'look',
        showzi6: 'l',

        // 鼻腔音
        danList7: [{
            num: 42,
            zi: 'm',
            index: 0,
            word: 'mode',
            image: 'https://r.bjwxjs.com/EnAudio/42.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2042.mp3',
            isPlay: false,
          },
          {
            num: 43,
            zi: 'n',
            word: 'neck',
            index: 1,
            image: 'https://r.bjwxjs.com/EnAudio/43.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2043.mp3',
            isPlay: false,
          },
          {
            num: 44,
            zi: 'ŋ',
            word: 'song',
            index: 2,
            image: 'https://r.bjwxjs.com/EnAudio/44.png',
            audio: 'https://r.bjwxjs.com/EnAudio/sound_2044.mp3',
            isPlay: false,
          }
        ],
        showImages7: 'https://r.bjwxjs.com/EnAudio/42.png',
        showWord7: 'mode',
        showzi7: 'm',
        queryStr:'',

          };
       
    },
    created() {
      
      this.queryListScren()
      this.from = this.$route.query.from
    },
    mounted() {
     
    },
    
    methods: {
      handWord(item) {
        let that = this
        let danList = this.danList
        if (danList[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList[item.index].isPlay = true
        this.danList = danList,
        this.showImages=item.image,
        this.showWord=item.word,
        this.showzi=item.zi
      },
      handWord1(item) {
        let that = this
        let danList1 = this.danList1
        if (danList1[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList1.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList1[item.index].isPlay = true
        this.danList1 = danList1,
        this.showImages1=item.image,
        this.showWord1=item.word,
        this.showzi1=item.zi
      },
      handWord2(item) {
        let that = this
        let danList2 = this.danList2
        if (danList2[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList2.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList2[item.index].isPlay = true
        this.danList2 = danList2,
        this.showImages2=item.image,
        this.showWord2=item.word,
        this.showzi2=item.zi
      },
      handWord3(item) {
        let that = this
        let danList3 = this.danList3
        if (danList3[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList3.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList3[item.index].isPlay = true
        this.danList3 = danList3,
        this.showImages3=item.image,
        this.showWord3=item.word,
        this.showzi3=item.zi
      },
      handWord4(item) {
        let that = this
        let danList4 = this.danList4
        if (danList4[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList4.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList4[item.index].isPlay = true
        this.danList4 = danList4,
        this.showImages4=item.image,
        this.showWord4=item.word,
        this.showzi4=item.zi
      },
      handWord5(item) {
        let that = this
        let danList5 = this.danList5
        if (danList5[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList5.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList5[item.index].isPlay = true
        this.danList5 = danList5,
        this.showImages5=item.image,
        this.showWord5=item.word,
        this.showzi5=item.zi
      },
      handWord6(item) {
        let that = this
        let danList6 = this.danList6
        if (danList6[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList6.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList6[item.index].isPlay = true
        this.danList6 = danList6,
        this.showImages6=item.image,
        this.showWord6=item.word,
        this.showzi6=item.zi
      },
      handWord7(item) {
        let that = this
        let danList7= this.danList7
        if (danList7[item.index].isPlay) {
          return false
        }
         this.$refs.audio.pause()
          that.$refs.audio.src = item.audio
        
        danList7.map(item1 => {
          item1.isPlay = false
        })
        this.$refs.audio.play()
        danList7[item.index].isPlay = true
        this.danList7 = danList7,
        this.showImages7=item.image,
        this.showWord7=item.word,
        this.showzi7=item.zi
      },

      overAudio(){
        let danList = this.danList
         danList.map(item => {
            item.isPlay = false
          })
          this.$refs.audio.pause()
          this.setData({
            danList: danList,
          })

      },
      hanTabs(name){
        this.mainActiveIndex = name
      },
      making(type){
        this.tabsIndex=type
        console.log(type)
        if(type == 3){
          this.queryListData = []
          this.queryListScren()
        }else{
          this.queryListData = []
          this.queryList1()
        }
      },
     
      clearBtn(){
        window.localStorage.removeItem('sessionId')
        this.$router.push('login?from='+this.from)
      },
      showBtn(data){
         if(this.tabsIndex == 3){
          this.$router.push({name:'wordPage',query:{id:data.screen_id,type:3}});
        }else{
          this.$router.push({name:'wordPage',query:{id:data.dict_id}});
        }
      },
      showStudy(data){
          
        if(this.tabsIndex == 3){
          this.$router.push({name:'studyPage',query:{id:data.screen_id,type:3}});
        }else{
          this.$router.push({name:'studyPage',query:{id:data.dict_id}});
        }
      },
      goLetter(data){
        if(this.tabsIndex == 3){
          this.$router.push({name:'TwoPlayerPKGame',query:{id:data.screen_id,type:3}});
        }else{
          this.$router.push({name:'TwoPlayerPKGame',query:{id:data.dict_id}});
        }
      },
      splitTpList(data){
        if(this.tabsIndex == 3){
          this.$router.push({name:'SplitPronun',query:{id:data.screen_id,type:3}});
        }else{
          this.$router.push({name:'SplitPronun',query:{id:data.dict_id}});
        }
      },
      
      queryList(){
      const that = this
        axios({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/dict',
          params: {
                page: that.page,
                num: that.num,
                q:this.queryStr,
                page:this.page,
            } 
          })
        .then((res) => {
          if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
              that.spinShow = false
              that.queryListData = res.data.data.dict_data
            }else{
              if(res.data.code == 4001){
                this.$router.push('login?from='+this.from)
              }else{
                that.$Message.error(res.data.msg);

              }
            }
        })
        .catch((err) => {
           that.$Message.error(err);
        });
       },
       queryList1(){
      const that = this
        axios({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/dict',
          params: {
                q:this.queryStr,
                page:this.page,
                num: 10,
                tab:1
            } 
          })
        .then((res) => {
          if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
              this.total=res.data.data.dict_data.length
              this.queryList()
            }else{
              if(res.data.code == 4001){
                this.$router.push('login?from='+this.from)
              }else{
                that.$Message.error(res.data.msg);
              }
            }
        })
        .catch((err) => {
           that.$Message.error(err);
        });
       },
       queryListScren(){
      const that = this
        axios({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/screen/pc',
          params: {
                q:this.queryStr,
                page:this.page,
                num: 10,
            } 
          })
        .then((res) => {
          if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
              console.log(res.data)
              that.spinShow = false
              that.total=res.data.data.count
              that.queryListData = res.data.data.screens
              
            }else{
              if(res.data.code == 4001){
                this.$router.push('login?from='+this.from)
              }else{
                that.$Message.error(res.data.msg);
              }
            }
        })
        .catch((err) => {
           that.$Message.error(err);
        });
       },
       handlePage(e){
        console.log(e)
          this.page = e
          if(this.tabsIndex == 3){
            this.queryListScren()
          }else{
            this.queryList()
          }
          
       }
    },
    // watch:{
    //     // 被侦听的变量count
    //     page(){
    //         this.queryList()
    //     }
    // },
  };
  </script>
  
  <style scoped>
    .loginBG{
        width: 100%;
        height: 100%;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_topic_bg.png') 0 0 / 100% 100% no-repeat;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .contentBox{
      overflow: auto;
      width: 1200px;
      margin: 0 auto;
      padding: 0 10px 0 10px;
    }
    .title{
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303133;
      margin-top: 50px;
      width: 1200px;
      margin: 50px auto 0;
      height: 52px;
      border-bottom: 2px solid #657180;
      
    }
    .title div{
      width: 120px;
      height: 50px;
      line-height: 50px;
      float: left;
      background-color: #fff;
      position: relative;
      text-align: center;
      margin-left: 20px;
      border-radius: 10px 10px 0 0;
      cursor:pointer;
      box-shadow: 0px 2px 10px 0px #95C9FF;

    }
    .actives{
      color: #fff;
      background-color: #2d8cf0 !important;
    }
    .actives p{
      position: absolute;
      bottom: -8px;
      width: 100%;
      height: 4px;
      background-color: #2d8cf0 !important;
    }
    .listItem{
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px #95C9FF, 0px 2px 10px 0px rgba(0,0,0,0.12);
      border-radius: 12px;
      height: 40px;
      position: relative;
      line-height: 40px;
      padding: 0 20px 0 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
      width: 800px;
      margin: 10px auto 0;
    }
    .postIcon{
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0,-50%);
      width: 10px;
      height: 40px;
      background: #FFB247;
      box-shadow: 0px 2px 10px 0px #95C9FF;
      border-radius: 0px 4px 4px 0px;
      box-sizing: border-box;
    }
    .showBtn{
      position: absolute;
      right: 20px;
      top:50%;
      transform: translate(0,-50%);
      width: 100px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 20px;
      padding: 0 !important;
    }
    .showBtn span{
      margin-bottom: 3px !important;
    }

    .showBtn1{
      position: absolute;
      right: 130px;
      top:50%;
      transform: translate(0,-50%);
      width: 100px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 20px;
      padding: 0 !important;
    }
    .showBtn1 span{
      margin-bottom: 3px !important;
    }

    .showBtn2{
      position: absolute;
      right: 240px;
      top:50%;
      transform: translate(0,-50%);
      width: 100px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 20px;
      padding: 0 !important;
    }
    .showBtn1 span{
      margin-bottom: 3px !important;
    }
    .showBtn3{
      position: absolute;
      right: 350px;
      top:50%;
      transform: translate(0,-50%);
      width: 100px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 20px;
      padding: 0 !important;
    }
    .showBtn3 span{
      margin-bottom: 3px !important;
    }

    .ivu-btn>span{
      vertical-align: center;
    }
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .ivu-spin-large /deep/.ivu-spin-dot{
      width: 100px;
      height: 100px;
    }
    .loginQr{
      width: 300px;
      height: 300px;
      background: #FFFFFF;
      border-radius: 10px;
      backdrop-filter: blur(10px);
      margin:200px auto 0;
      padding: 20px;
    }
    .loginInfo{
      font-size: 26px;
      font-family: HiraginoSansGB-W3, HiraginoSansGB;
      font-weight: normal;
      color: #303133;
      letter-spacing: 4px;
      text-align: center;
      margin-top: 30px;
    }
    .loginQr img{
        width: 100%;
        height: 100%;
        margin-bottom: 10px;

    }
    .clearBtn{
      position:fixed;
      top: 40px;
      right: 50px;
    }
    .fayin{
      width: 1200px;
      margin: 0 auto;
      display: flex;
    }

    .ivu-menu-item{
      height: 60px;
      line-height: 30px;
      font-size: 26px;
    }
    .ivu-menu{
      width: 160px !important;
      margin-top: 50px;
    }
    .shouMin{
      width: 500px;
      margin-top: 50px;
    }


    .danItem{
      width: 80px;
      border-radius: 6px;
      height: 80px;
      border: 2px solid rgba(0, 0, 0, .2);
      margin-bottom: 30px;
      padding:10px;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin-left: 20px;
      background-color: #fff;
      cursor: pointer;

    }
    .titiles{
      font-size: 22px;
      color: rgba(0, 0, 0, .6);
      height: 22px;
      line-height: 22px;
    }
    .wordIten{
      text-align: center;
      height: 26px;
      font-size: 32px;
      line-height: 26px;
      color: #417EFA;
      font-weight: 600;

    }
    .audioIcon{
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 30px;
      background: url(https://r.bjwxjs.com/EnImage/en_init_icons_pay.png) 0 0 / 100% 100% no-repeat;
    }
    .shouMin{
      text-align: center;
    }
    .binItem{
      text-align: center;
      height: 70px;
      font-size: 70px;
      font-weight: 600;
      line-height: 70px;
    }
    .binWord{
      text-align: center;
      height: 70px;
      font-size: 70px;
      font-weight: 600;
      line-height: 70px;
      margin: 30px 0;
    }
    .shouMin img{
      width: 400px;
      height: 400px;
      margin: 0 auto;
    }
    .sharBtn{
      position: fixed;
      bottom: 160px;
      right: 130px;
      color: #ffffff;
      width: 300px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background-color: #FEBC67;
    }
    .danBoxContent{
      width: 500px;
      /* display: flex;
      justify-content: space-between;
      flex-flow: row wrap; */
      padding:0 20px;
      box-sizing: border-box;
      margin-top: 50px;
    }
    .audiosBox{
        position: fixed;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .bottomBox{
      width: 600px;
      margin: 0 auto;
      text-align: center;
      background:#fff;
      height: 40px;
      border-radius: 8px;
      padding: 10px 15px;
      box-sizing: border-box;
      margin-top: 20px;
    }
   /deep/ .ivu-page-simple .ivu-page-simple-pager input{
      width: 40px;
    }
   /deep/ .ivu-input-group{
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin: 20px auto;
      width: 800px;
    }

    /deep/ .ivu-input-group .ivu-input{
      height: 40px; 
      line-height: 40px;
      box-sizing: border-box;
    }
    /deep/ .ivu-input-inner-container{
      height: 40px; 
      line-height: 40px;
      width: 800px;
    }
  .jiantouBox{
    width: 80px;
    height: 80px;
    margin-left: 100px;
    margin-top: -10px;

  }
  .jiantouBox img{
    width: 100%;
    height: 100%;
  }
  .infos{
    color:red;
    font-size: 20px;
  }
  </style>
  